import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db, hasFirebaseConfig } from './lib/firebase';
import { hydrateMistakesFromCloud, type JournalMistake } from './mistakes-store';

const MISTAKES_CLOUD_SESSION_PREFIX = 'vm-mistakes-cloud-loaded:v1:';

function getSessionCacheKey(userId: string) {
  return `${MISTAKES_CLOUD_SESSION_PREFIX}${userId}`;
}

function canUseSessionStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

function wasLoadedThisSession(userId: string) {
  return canUseSessionStorage() && window.sessionStorage.getItem(getSessionCacheKey(userId)) === '1';
}

function markLoadedThisSession(userId: string) {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(getSessionCacheKey(userId), '1');
}

export async function loadMistakesFromCloud(userId: string) {
  if (!hasFirebaseConfig || !db || !userId || wasLoadedThisSession(userId)) {
    return;
  }

  const snapshot = await getDoc(doc(db, 'users', userId));
  const snapshotData = snapshot.exists() ? (snapshot.data() as Record<string, unknown>) : undefined;

  if (snapshotData?.mistakesJournal) {
    hydrateMistakesFromCloud(userId, snapshotData.mistakesJournal);
  }

  markLoadedThisSession(userId);
}

export async function saveMistakesToCloud(userId: string, mistakesJournal: JournalMistake[]) {
  if (!hasFirebaseConfig || !db || !userId) {
    return;
  }

  await setDoc(
    doc(db, 'users', userId),
    {
      mistakesJournal,
      mistakesUpdatedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );

  markLoadedThisSession(userId);
}
